import React from "react";

const ComingSoonPage = () => {
    return (
        <div className="h-full w-full flex flex-col items-center justify-center py-10">

            <div className="text-center">
                <h1 className="text-3xl font-bold text-theme_clr1 mb-3">
                    🚧 Coming Soon
                </h1>

                <p className="text-theme_clr1 text-opacity-70 font-medium text-lg max-w-md">
                    This feature is currently under development.  
                    Stay tuned — something amazing is on the way!
                </p>
            </div>

            <div className="mt-6 animate-bounce">
                <i className="bi bi-tools text-6xl text-theme_clr2"></i>
            </div>
        </div>
    );
};

export default ComingSoonPage;
